import { QueryObserverSuccessResult, useQuery } from "@tanstack/react-query";
import { Employers } from "@src/api/v1/Employers";
import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";
import {
  ModelsEmployer,
  ResponseEmployersEmployerReferralToolkitResponse,
} from "@src/api/v1/data-contracts";

export const useEmployerReferralToolkitsQuery = (employerId: string) =>
  useQuery({
    queryKey: ["referral-toolkit", employerId],
    queryFn: () =>
      new Employers(OpenUpHttpClient).getReferralToolkit(employerId),
    enabled: !!employerId,
    suspense: false,
  }) as QueryObserverSuccessResult<ResponseEmployersEmployerReferralToolkitResponse>;
export const useEmployersQuery = (
  companyName: string,
  enabled: boolean = true,
) =>
  useQuery({
    queryKey: [`employers`, companyName],
    queryFn: () => {
      if (enabled === false) return Promise.resolve([] as ModelsEmployer[]);
      return new Employers(OpenUpHttpClient).getEmployers({
        companyName,
      });
    },
    suspense: false,
  }) as QueryObserverSuccessResult<ModelsEmployer[]>;
